<template>
    <div>
        <div class='topbg'></div>
        <div style="display: flex;width: 1200px;margin: 0 auto;margin-top: 100px;">

            <div class="menu">
                <el-menu active-text-color="#323335" background-color="#FBFBFB" :default-active="defaultmenu"
                    text-color="#323335">
                    <el-tooltip class="box-item" effect="dark" hide-after=10 placement="right-start"
                        v-for="(item, index) in headersList" :key="item.id" :content="item.title">
                        <el-menu-item :index="item.id" @click="totip(item.id)">
                            <div :style="{ marginLeft: getMarginLeft(item.type) }"></div>
                            <span
                                :class="{ 'menu-text-1': item.type === 'header1', 'menu-text-2': item.type !== 'header1' }">
                                {{ item.title }}
                            </span>
                        </el-menu-item>
                    </el-tooltip>
                </el-menu>
            </div>
            <!-- 占位 -->
            <div class="menu2"></div>



            <div class="content">


                <div v-if="active == 1">
                    <div class="title1" id="1">1.远程异地评标目录服务组件简介</div>
                    <div class="jj-text1">
                        中国招标投标公共服务平台通过电子招标投标公共服务平台网络体系免费提供实现全国工程建设招标投标领域远程异地评标的公共服务组件，简称“远程异地评标目录服务组件”。该组件基于“技术中立、兼容开放、源码公开、使用免费”的原则，通过本地化部署实现电子招标投标交易系统、电子评标工具、场地管理系统、场地音视频监控工具、场地视频会议系统、专家库共享抽取工具“点对点”互联和数据泛中心化交互。






                    </div>

                    <div class="jj-text1">
                        远程异地评标目录服务组件提供和电子招标投标交易平台、电子评标工具、场地管理系统、场地音视频监控工具、场地视频会议系统和专家库共享抽取工具的对接和开通功能，包括：公共服务平台自助开通、交易平台自助开通、主副场地工位目录和主副场专家库目录自助开通、运行状态监测、用户操作日志记录查询。

                    </div>










                </div>


                <div v-if="active == 2" style="height: 100%;">
                    <div class="title1" id="2">2.远程异地评标目录服务组件源码</div>





                    <div class="tipbox">
                        <img src="../../assets/img/ico3.png" alt="" class="downico">
                        <span class="tip-text1"> &nbsp; &nbsp; &nbsp;发布时间：
                            2024-12-23 12:21:21
                        </span>

                    </div>

                    <div class="urltext-box">
                        <div class="urltext1">源码链接地址:</div>

                        <div class="urltext2" @click="downym">https://gitee.com/cebpubservice</div>
                    </div>


                    <div class="codeimg">
                        <img src="../../assets/img/codeview.png" alt="" style="width: 100%;height: 100%">
                    </div>






                    <div style="display: flex;margin-top: 24px;">
                    </div>

                    <div>



                    </div>
                </div>


                <div v-if="active == 3">
                    <div class="title1" id="3">3.远程异地评标目录服务组件对接指南</div>
                    <div class="title1" id="3-1">3.1 SDK对接</div>
                    <div class="info-text">
                        电子交易系统开发语言为JAVA时，可采用SDK方式对接，以减轻交易系统对接远程异地目录服务组件工作量。
                    </div>

                    <div class="title2" id="3-1-1"> 3.1.1 环境依赖 </div>

                    <div class="info-text">
                        （1）Java运行环境：JDK1.8；
                    </div>

                    <div class="info-text">
                        （2）网络连通性：确保交易系统与远程异地目录服务组件间网络互通无阻。
                    </div>


                    <div class="title3" id="3-1-2"> 3.1.2 电子交易系统SDK集成 </div>

                    <div class="title4" id="3-1-2-1"> 3.1.2.1 远程异地项目登记SDK集成，用于推送项目信息和远程异地评标项目登记预约信息 </div>

                    <div class="title5" id="3-1-2-1-1"> 第1步：POM文件引入远程异地项目登记SDK </div>

                    <div class="info-text2">
                        首先，在项目的 pom.xml 文件中引入远程异地项目登记 SDK 及其核心依赖包，只需一次引入即可：
                    </div>

                    <div>
                        <showcode :tocode="bidcode.code1"></showcode>
                    </div>


                    <div class="title5" id="3-1-2-1-2"> 第2步：初始化远程异地项目登记SDK中的配置参数 </div>

                    <div class="info-text2">
                        初始化远程异地项目登记SDK中的配置参数，包括远程异地评标目录服务组件地址serviceUrl、电子交易系统编码tradingSystemCode，clientId
                        、clientSecret、signatureSecret用于电子交易系统和远程异地评标目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                    </div>

                    <div>
                        <showcode :tocode="bidcode.code2"></showcode>
                    </div>


                    <div class="title4" id="3-1-2-2"> 3.1.2.2远程异地项目开标SDK集成，用于推送投标人信息 </div>
                    <div class="title5" id="3-1-2-2-1">第1步：POM文件引入远程异地项目开标SDK </div>
                    <div class="info-text2">
                        首先，在项目的 pom.xml 文件中引入远程异地项目开标 SDK 及其核心依赖包，只需一次引入即可：
                    </div>
                    <div>
                        <showcode :tocode="bidcode.code3"></showcode>
                    </div>


                    <div class="title5" id="3-1-2-2-2">第2步：初始化远程异地项目开标SDK中的配置参数 </div>
                    <div class="info-text2">
                        初始化远程异地项目开标SDK中的配置参数，包括远程异地评标目录服务组件地址serviceUrl、电子交易系统编码tradingSystemCode，clientId
                        、clientSecret、signatureSecret用于电子交易系统和远程异地评标目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                    </div>
                    <div>
                        <showcode :tocode="bidcode.code4"></showcode>
                    </div>

                    <div class="title4" id="3-1-2-3"> 3.1.2.3 远程异地项目评标SDK集成，用于推送评标结束状态 </div>

                    <div class="title5" id="3-1-2-3-1">第1步：POM文件引入远程异地项目评标SDK </div>
                    <div class="info-text2">
                        首先，在项目的 pom.xml 文件中引入远程异地项目评标 SDK 及其核心依赖包，只需一次引入即可：
                    </div>
                    <div>
                        <showcode :tocode="bidcode.code5"></showcode>
                    </div>

                    <div class="title5" id="3-1-2-3-2">第2步：初始化远程异地项目评标SDK中的配置参数</div>

                    <div class="info-text2">
                        初始化远程异地项目评标SDK中的配置参数，包括远程异地评标目录服务组件地址serviceUrl、电子交易系统编码tradingSystemCode，clientId
                        、clientSecret、signatureSecret用于电子交易系统和远程异地评标目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                    </div>


                    <div>
                        <showcode :tocode="bidcode.code6"></showcode>
                    </div>

                    <div class="title4" id="3-1-2-4"> 3.1.2.4 远程异地项目归集归档SDK集成，用于查询评标专家信息、推送专家劳务报酬支付信息和推送专家履职异常行为信息</div>

                    <div class="title5" id="3-1-2-4-1">第1步：POM文件引入远程异地项目归集归档SDK</div>
                    <div>

                        <div class="info-text2">
                            首先，在项目的 pom.xml 文件中引入远程异地项目归集归档 SDK 及其核心依赖包，只需一次引入即可：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code7"></showcode>
                        </div>
                        <div class="title5" id="3-1-2-4-2">第2步：初始化远程异地项目归集归档SDK中的配置参数</div>

                        <div class="info-text2">
                            初始化远程异地项目归集归档SDK中的配置参数，包括远程异地评标目录服务组件地址serviceUrl、电子交易系统编码tradingSystemCode，clientId
                            、clientSecret、signatureSecret用于电子交易系统和远程异地评标目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                        </div>


                        <div>
                            <showcode :tocode="bidcode.code8"></showcode>
                        </div>


                        <div class="title3" id="3-1-3"> 3.1.3 电子评标工具SDK集成 </div>
                        <div class="title4" id="3-1-3-1"> 3.1.3.1 项目评标SDK集成，用于推送专家主动回避信息</div>

                        <div class="title5" id="3-1-3-1-1">第1步：POM文件引入项目评标SDK</div>
                        <div class="info-text2">
                            首先，在项目的pom.xml文件中引入项目评标SDK及其核心依赖包，只需一次引入即可：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code9"></showcode>
                        </div>
                        <div class="title5" id="3-1-3-1-2">第2步：初始化项目评标SDK中的配置参数</div>
                        <div class="info-text2">
                            初始化项目评标SDK中的配置参数，包括远程异地评标目录服务组件serviceUrl、电子评标工具编码evaluationToolCode、clientId、clientSecret、signatureSecret用于电子评标工具和远程异地评标目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code10"></showcode>
                        </div>





                        <div class="title3" id="3-1-4"> 3.1.4 场地管理系统SDK集成 </div>
                        <div class="title4" id="3-1-4-1"> 3.1.4.1 场所工位信息同步SDK集成，用于同步场地、评标区、评标室和评标工位信息</div>

                        <div class="title5" id="3-1-4-1-1">第1步：POM文件引入场所工位信息同步SDK</div>
                        <div class="info-text2">
                            首先，在项目的 pom.xml 文件中引入场所工位信息同步SDK及其核心依赖包，只需一次引入即可：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code11"></showcode>
                        </div>
                        <div class="title5" id="3-1-4-1-2">第2步：初始化场所工位信息同步SDK中的配置参数</div>

                        <div class="info-text2">
                            初始化场所工位信息同步SDK中的配置参数，包括远程异地评标和评标专家库共享管理终端服务地址serviceUrl、场地管理系统编码siteManagementSystemCode、clientId
                            、clientSecret、signatureSecret用于场地管理系统和（远程异地评标和评标专家库共享管理终端服务）交互通信中的建立安全链路，只需初始化时配置一次：
                        </div>

                        <div>
                            <showcode :tocode="bidcode.code12"></showcode>
                        </div>


                        <div class="title4" id="3-1-4-2"> 3.1.4.2 场所工位预约结果SDK集成，用于推送场所工位预约结果或变更结果</div>

                        <div class="title5" id="3-1-4-2-1">第1步：POM文件引入场所工位预约结果SDK</div>

                        <div class="info-text2">
                            首先，在项目的 pom.xml 文件中引入远程异地场所工位预约结果 SDK 及其核心依赖包，只需一次引入即可：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code13"></showcode>
                        </div>
                        <div class="title5" id="3-1-4-2-2">第2步：初始化远程异地场所工位预约SDK中的配置参数</div>

                        <div class="info-text2">
                            初始化远程异地场所工位预约SDK中的配置参数，包括远程异地评标目录服务组件地址serviceUrl、场地管理系统编码siteManagementSystemCode、clientId
                            、clientSecret、signatureSecret用于场地管理系统和远程异地评标目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                        </div>

                        <div>
                            <showcode :tocode="bidcode.code14"></showcode>
                        </div>






                        <div class="title3" id="3-1-5"> 3.1.5 远程异地评标项目登记工具SDK集成 </div>
                        <div class="title4" id="3-1-5-1"> 3.1.5.1
                            查询设置开通目录SDK集成，用于查询电子评标工具目录、查询场地视频会议系统信息和查询主副场地工位目录</div>

                        <div class="title5" id="3-1-5-1-1">第1步：POM文件引入查询设置开通目录SDK</div>
                        <div class="info-text2">
                            首先，在项目的 pom.xml 文件中引入查询设置开通目录SDK及其核心依赖包，只需一次引入即可：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code15"></showcode>
                        </div>
                        <div class="title5" id="3-1-5-1-2">第2步：初始化查询设置开通目录SDK中的配置参数</div>

                        <div class="info-text2">
                            初始化查询设置开通目录SDK中的配置参数，包括远程异地评标目录服务组件服务地址serviceUrl、远程异地评标项目登记工具编码remoteBidEvaluationProjectRegistrationToolCode，clientId 、clientSecret、signatureSecret用于远程异地评标项目登记工具和远程异地评标目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                        </div>

                        <div>
                            <showcode :tocode="bidcode.code16"></showcode>
                        </div>
                        <div class="title4" id="3-1-5-2"> 3.1.5.2 远程异地项目登记SDK集成，用于推送远程异地评标项目登记预约信息</div>

                        <div class="title5" id="3-1-5-2-1">第1步：POM文件引入远程异地项目登记SDK</div>

                        <div class="info-text2">
                            首先，在项目的 pom.xml 文件中引入远程异地项目登记SDK及其核心依赖包，只需一次引入即可：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code17"></showcode>
                        </div>
                        <div class="title5" id="3-1-5-2-2">第2步：初始化远程异地项目登记SDK中的配置参数</div>

                        <div class="info-text2">
                            初始化远程异地项目登记SDK中的配置参数，包括远程异地评标目录服务组件服务地址serviceUrl、远程异地评标项目登记工具编码remoteBidEvaluationProjectRegistrationToolCode，clientId
                            、clientSecret、signatureSecret用于远程异地评标项目登记工具和远程异地评标目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                        </div>

                        <div>
                            <showcode :tocode="bidcode.code18"></showcode>
                        </div>


                        <div class="title4" id="3-1-5-3"> 3.1.5.3 远程异地项目归集归档SDK集成，用于查询评标专家信息</div>

                        <div class="title5" id="3-1-5-3-1">第1步：POM文件引入远程异地项目归集归档SDK</div>

                        <div class="info-text2">
                            首先，在项目的 pom.xml 文件中引入远程异地项目归集归档SDK及其核心依赖包，只需一次引入即可：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code19"></showcode>
                        </div>
                        <div class="title5" id="3-1-5-3-2">第2步：初始化远程异地项目归集归档SDK中的配置参数</div>
                        <div class="info-text2">
                            初始化远程异地项目归集归档SDK中的配置参数，包括远程异地评标目录服务组件服务地址serviceUrl、远程异地评标项目登记工具编码remoteBidEvaluationProjectRegistrationToolCode，clientId
                            、clientSecret、signatureSecret用于远程异地评标项目登记工具和远程异地评标目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code20"></showcode>
                        </div>









                        <div class="title3" id="3-1-6"> 3.1.6 场所工位预约工具SDK集成 </div>
                        <div class="title4" id="3-1-6-1"> 3.1.6.1 查询设置开通目录SDK集成，用于查询主场地工位目录和查询主副场地工位目录</div>

                        <div class="title5" id="3-1-6-1-1">第1步：POM文件引入查询设置开通目录SDK</div>
                        <div class="info-text2">
                            首先，在项目的 pom.xml 文件中引入查询设置开通目录SDK及其核心依赖包，只需一次引入即可：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code21"></showcode>
                        </div>
                        <div class="title5" id="3-1-6-1-2">第2步：初始化查询设置开通目录SDK中的配置参数</div>

                        <div class="info-text2">
                            初始化查询设置开通目录SDK中的配置参数，包括远程异地评标目录服务组件服务地址serviceUrl、场所工位预约工具编码placeSeatReservationToolCode，clientId 、clientSecret、signatureSecret用于场所工位预约工具和远程异地评标目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                        </div>

                        <div>
                            <showcode :tocode="bidcode.code22"></showcode>
                        </div>



                        <div class="title4" id="3-1-6-2"> 3.1.6.2 场所工位预约申请SDK集成，用于查询场所工位空闲信息和推送场所工位预约信息等</div>

                        <div class="title5" id="3-1-6-2-1">第1步：POM文件引入场所工位预约申请SDK</div>
                        <div class="info-text2">
                            首先，在项目的 pom.xml 文件中引入场所工位预约申请SDK及其核心依赖包，只需一次引入即可：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code23"></showcode>
                        </div>
                        <div class="title5" id="3-1-6-2-2">第2步：初始化场所工位预约申请SDK中的配置参数</div>

                        <div class="info-text2">
                            初始化场所工位预约申请SDK中的配置参数，包括远程异地评标目录服务组件服务地址serviceUrl、场所工位预约工具编码placeSeatReservationToolCode，clientId
                            、clientSecret、signatureSecret用于场所工位预约工具和远程异地评标目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                        </div>

                        <div>
                            <showcode :tocode="bidcode.code24"></showcode>
                        </div>







                        <div class="title3" id="3-1-7"> 3.1.7 场地专家签到工作台SDK集成 </div>
                        <div class="title4" id="3-1-7-1"> 3.1.7.1 场地专家签到SDK集成，用于推送场地专家签到信息</div>

                        <div class="title5" id="3-1-7-1-1">第1步：POM文件引入场地专家签到SDK</div>
                        <div class="info-text2">
                            首先，在项目的 pom.xml 文件中引入场地专家签到SDK及其核心依赖包，只需一次引入即可：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code25"></showcode>
                        </div>
                        <div class="title5" id="3-1-7-1-2">第2步：初始化场地专家签到SDK中的配置参数</div>

                        <div class="info-text2">
                            初始化场地专家签到SDK中的配置参数，包括远程异地评标目录服务组件服务地址serviceUrl、场地专家签到工作台编码placeExpertCheckInToolCode，clientId
                            、clientSecret、signatureSecret用于场地专家签到工作台和远程异地评标目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                        </div>

                        <div>
                            <showcode :tocode="bidcode.code26"></showcode>
                        </div>



                        <div class="title4" id="3-1-7-2"> 3.1.7.2 分配专家物理工位SDK集成，用于查询场地工位未分配信息和推送已分配评标工位信息</div>

                        <div class="title5" id="3-1-7-2-1">第1步：POM文件引入分配专家物理工位SDK</div>
                        <div class="info-text2">
                            首先，在项目的 pom.xml 文件中引入分配专家物理工位 SDK 及其核心依赖包，只需一次引入即可：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code27"></showcode>
                        </div>
                        <div class="title5" id="3-1-7-2-2">第2步：初始化分配专家物理工位SDK中的配置参数</div>

                        <div class="info-text2">
                            初始化分配专家物理工位SDK中的配置参数，包括远程异地评标目录服务组件服务地址serviceUrl、场地专家签到工作台编码placeExpertCheckInToolCode，clientId 、clientSecret、signatureSecret用于场地专家签到工作台和远程异地评标目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                        </div>

                        <div>
                            <showcode :tocode="bidcode.code28"></showcode>
                        </div>




                        <div class="title3" id="3-1-8"> 3.1.8  场地专家评标登录工作台SDK集成 </div>
                        <div class="title4" id="3-1-8-1">3.1.8.1 场地专家评标登录SDK集成，用于接收场地专家评标登录身份信息</div>

                        <div class="title5" id="3-1-8-1-1">第1步：POM文件引入场地专家评标登录SDK</div>
                        <div class="info-text2">
                            首先，在项目的 pom.xml 文件中引入场地专家评标登录SDK及其核心依赖包，只需一次引入即可：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code29"></showcode>
                        </div>

                        <div class="title5" id="3-1-8-1-2">第2步：初始化场地专家评标登录SDK中的配置参数</div>
                        <div class="info-text2">
                            初始化场地专家评标登录SDK中的配置参数，包括远程异地评标目录服务组件服务地址serviceUrl、场地专家评标登录工作台编码placeExpertBidEvaluationLoginToolCode，clientId 、clientSecret、signatureSecret用于场地专家评标登录工作台和远程异地评标目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code30"></showcode>
                        </div>




                        <!-- <div class="title3" id="3-1-9"> 3.1.9  专家库共享抽取工具SDK集成 </div>
                        <div class="title4" id="3-1-9-1">3.1.9.1 查询设置开通目录SDK集成，用于查询主副场评标专家库和查询专家库的交易中心场所抽取终端目录</div>

                        <div class="title5" id="3-1-9-1-1">第1步：POM文件引入场地专家评标登录SDK</div>
                        <div class="info-text2">
                            首先，在项目的 pom.xml 文件中引入专家库共享抽取目录服务组件SDK及其核心依赖包：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code31"></showcode>
                        </div>

                        <div class="title5" id="3-1-9-1-2">第2步：初始化场地专家评标登录SDK中的配置参数</div>
                        <div class="info-text2">
                            初始化专家库共享抽取SDK中的配置参数，包括评标专家库目录服务地址serviceUrl、专家库共享抽取工具编码expertLibraryShareExtractToolCode，clientId 、clientSecret、signatureSecret用于专家库共享抽取工具和评标专家库目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code32"></showcode>
                        </div> -->


                        <div class="title3" id="3-1-9"> 3.1.9  专家库共享抽取工具SDK集成 </div>
                        <div class="title4" id="3-1-9-1">3.1.9.1 查询设置开通目录SDK集成，用于查询主副场评标专家库</div>

                        <div class="title5" id="3-1-9-1-1">第1步：POM文件引入查询设置开通目录SDK</div>
                        <div class="info-text2">
                            首先，在项目的 pom.xml 文件中引入查询设置开通目录SDK及其核心依赖包：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code33"></showcode>
                        </div>

                        <div class="title5" id="3-1-9-1-2">第2步：初始化查询设置开通目录SDK的配置参数</div>
                        <div class="info-text2">
                            初始化查询设置开通目录SDK中的配置参数，包括评标专家库目录服务地址serviceUrl、专家库共享抽取工具编码expertLibraryShareExtractToolCode，clientId 、clientSecret、signatureSecret用于专家库共享抽取工具和评标专家库目录服务组件交互通信中的建立安全链路，只需初始化时配置一次：
                        </div>
                        <div>
                            <showcode :tocode="bidcode.code34"></showcode>
                        </div>



                    </div>




                </div>

            </div>

        </div>
    </div>
</template>

<script lang='ts' setup>
import { reactive, toRefs, onBeforeUnmount, ref, shallowRef, onMounted, nextTick } from 'vue'

import showcode from '../../components/showcode/index.vue'


import bidcode from './codedata/bidEvaluationComponent'


//目录标题间距
const getMarginLeft = (type: string) => {
    switch (type) {
        case 'header1':
            return '0px';
        case 'header2':
            return '10px';
        case 'header3':
            return '20px';
        case 'header4':
            return '30px';
        case 'header5':
            return '40px';
        default:
            return '0px'; // 默认返回0px
    }
}

let active = ref(1)
//点击目录页面滚定
const totip = (id: any) => {
    if (id == 1) {
        active.value = 1
    }
    else if (id == 2) {
        active.value = 2
    } else {
        active.value = 3
        setTimeout
            (() => {
                const element = document.getElementById(id);
                if (element) {
                    // 计算目标元素距离页面顶部的距离  
                    const top = element.offsetTop - 168;
                    // 滚动到该位置，{ behavior: 'smooth' } 表示平滑滚动  
                    window.scrollTo({
                        top: top,
                        behavior: 'smooth'
                    });
                }
            }, 10);
    }

}




// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef()

// 内容 HTML
const valueHtml = ref('')

const downym = () => {
    window._czc.push(['_trackEvent', '远程异地评标目录服务组件', '查看源码', '查看远程异地评标目录服务组件源码'])

    window.open('https://gitee.com/cebpubservice', '_blank')
}

const toolbarConfig = {}
const editorConfig = { placeholder: '请输入内容...', readOnly: true, scroll: false }
// readOnly : true

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
    const editor = editorRef.value
    if (editor == null) return
    editor.destroy()
})
let headersList = ref([
    { id: '1', title: '1.组件简介', type: 'header1' },
    { id: '2', title: '2.组件源码', type: 'header1' },
    { id: '3', title: '3.组件对接指南', type: 'header1' },


    { id: '3-1', title: '3.1 SDK对接', type: 'header2' },
    { id: '3-1-1', title: '3.1.1 环境依赖', type: 'header3' },
    { id: '3-1-2', title: '3.1.2 电子交易系统SDK集成', type: 'header3' },
    { id: '3-1-2-1', title: '3.1.2.1 远程异地项目登记SDK', type: 'header4' },
    { id: '3-1-2-1-1', title: '第1步：POM文件引入远程异地项目登记SDK', type: 'header5' },
    { id: '3-1-2-1-2', title: '第2步：初始化远程异地项目登记SDK中的配置参数', type: 'header5' },
    { id: '3-1-2-2', title: '3.1.2.2 远程异地项目开标SDK', type: 'header4' },
    { id: '3-1-2-2-1', title: '第1步：POM文件引入远程异地项目开标SDK', type: 'header5' },
    { id: '3-1-2-2-2', title: '第2步：初始化远程异地项目开标SDK中的配置参数', type: 'header5' },
    { id: '3-1-2-3', title: '3.1.2.3 远程异地项目评标SDK', type: 'header4' },
    { id: '3-1-2-3-1', title: '第1步：POM文件引入远程异地项目评标SDK', type: 'header5' },
    { id: '3-1-2-3-2', title: '第2步：初始化远程异地项目评标SDK中的配置参数', type: 'header5' },

    { id: '3-1-2-4', title: '3.1.2.4 远程异地项目归集归档SDK', type: 'header4' },
    { id: '3-1-2-4-1', title: '第1步：POM文件引入远程异地项目归集归档SDK', type: 'header5' },
    { id: '3-1-2-4-2', title: '第2步：初始化远程异地项目归集归档SDK中的配置参数', type: 'header5' },


    { id: '3-1-3', title: '3.1.3 电子评标工具SDK集成', type: 'header3' },

    { id: '3-1-3-1', title: '3.1.3.1 项目评标SDK', type: 'header4' },
    { id: '3-1-3-1-1', title: '第1步：POM文件引入项目评标SDK', type: 'header5' },
    { id: '3-1-3-1-2', title: '第2步：初始化项目评标SDK中的配置参数', type: 'header5' },


    { id: '3-1-4', title: '3.1.4 场地管理系统SDK集成', type: 'header3' },

    { id: '3-1-4-1', title: '3.1.4.1 场所工位信息同步SDK', type: 'header4' },
    { id: '3-1-4-1-1', title: '第1步：POM文件引入场所工位信息同步SDK', type: 'header5' },
    { id: '3-1-4-1-2', title: '第2步：初始化场所工位信息同步SDK中的配置参数', type: 'header5' },


    { id: '3-1-4-2', title: '3.1.4.2 场所工位预约结果SDK', type: 'header4' },
    { id: '3-1-4-2-1', title: '第1步：POM文件引入场所工位预约结果SDK', type: 'header5' },
    { id: '3-1-4-2-2', title: '第2步：初始化远程异地场所工位预约SDK中的配置参数', type: 'header5' },

    { id: '3-1-5', title: '3.1.5 远程异地评标项目登记工具SDK集成', type: 'header3' },
    { id: '3-1-5-1', title: '3.1.5.1 查询设置开通目录SDK', type: 'header4' },
    { id: '3-1-5-1-1', title: '第1步：POM文件引入查询设置开通目录SDK', type: 'header5' },
    { id: '3-1-5-1-2', title: '第2步：初始化查询设置开通目录SDK中的配置参数', type: 'header5' },


    { id: '3-1-5-2', title: '3.1.5.2 远程异地项目登记SDK', type: 'header4' },
    { id: '3-1-5-2-1', title: '第1步：POM文件引入远程异地项目登记SDK', type: 'header5' },
    { id: '3-1-5-2-2', title: '第2步：初始化远程异地项目登记SDK中的配置参数', type: 'header5' },


    { id: '3-1-5-3', title: '3.1.5.3 远程异地项目归集归档SDK', type: 'header4' },
    { id: '3-1-5-3-1', title: '第1步：POM文件引入远程异地项目归集归档SDK', type: 'header5' },
    { id: '3-1-5-3-2', title: '第2步：初始化远程异地项目归集归档SDK中的配置参数', type: 'header5' },

    { id: '3-1-6', title: '3.1.6 场所工位预约工具SDK集成', type: 'header3' },
    { id: '3-1-6-1', title: '3.1.6.1 查询设置开通目录SDK', type: 'header4' },
    { id: '3-1-6-1-1', title: '第1步：POM文件引入查询设置开通目录SDK', type: 'header5' },
    { id: '3-1-6-1-2', title: '第2步：初始化查询设置开通目录SDK中的配置参数', type: 'header5' },

    { id: '3-1-6-2', title: '3.1.6.2 场所工位预约申请SDK', type: 'header4' },
    { id: '3-1-6-2-1', title: '第1步：POM文件引入场所工位预约申请SDK', type: 'header5' },
    { id: '3-1-6-2-2', title: '第2步：初始化场所工位预约申请SDK中的配置参数', type: 'header5' },




    { id: '3-1-7', title: '3.1.7 场地专家签到工作台SDK集成', type: 'header3' },
    { id: '3-1-7-1', title: '3.1.7.1 场地专家签到SDK', type: 'header4' },
    { id: '3-1-7-1-1', title: '第1步：POM文件引入场地专家签到SDK', type: 'header5' },
    { id: '3-1-7-1-2', title: '第2步：初始化场地专家签到SDK中的配置参数', type: 'header5' },


    { id: '3-1-7-2', title: '3.1.7.2 分配专家物理工位SDK', type: 'header4' },
    { id: '3-1-7-2-1', title: '第1步：POM文件引入分配专家物理工位SDK', type: 'header5' },
    { id: '3-1-7-2-2', title: '第2步：初始化分配专家物理工位SDK中的配置参数', type: 'header5' },


    { id: '3-1-8', title: '3.1.8 场地专家评标登录工作台SDK集成', type: 'header3' },
    { id: '3-1-8-1', title: '3.1.8.1 场地专家评标登录SDK', type: 'header4' },
    { id: '3-1-8-1-1', title: '第1步：POM文件引入场地专家评标登录SDK', type: 'header5' },
    { id: '3-1-8-1-2', title: '第2步：初始化场地专家评标登录SDK中的配置参数', type: 'header5' },


    { id: '3-1-9', title: '3.1.9 专家库共享抽取工具SDK集成', type: 'header3' },
    { id: '3-1-9-1', title: '3.1.9.1 查询设置开通目录SDK', type: 'header4' },
    { id: '3-1-9-1-1', title: '第1步：POM文件引入场地专家评标登录SDK', type: 'header5' },
    { id: '3-1-9-1-2', title: '第2步：初始化场地专家评标登录SDK中的配置参数', type: 'header5' },








])

// const handleCreated = (editor: IDomEditor) => {
//     editorRef.value = editor 
//     headersList.value = editor.getElemsByTypePrefix('header')
//     headersList.value = headersList.value.filter(item => {
//     return item.children[0] && item.children[0].text;
// });
//     console.log(headersList.value, 'headers',headersList.value.length);
// }
//获取目录数据
// const handleChange = (editor: IDomEditor) => {
//     editorRef.value = editor
//     headersList.value = editor.getElemsByTypePrefix('header')
//     headersList.value = headersList.value.filter(item => {
//         return item.children[0] && item.children[0].text;
//     });
//     console.log(headersList.value, 'headers', headersList.value.length);
// }


let mode = ref('default')  // 或 'simple'

</script>
<style scoped lang="scss">
 @import "./component.scss";

</style>